import { BorderRadiusInterface } from 'types';
import { stringOrNumberHelper } from './stringOrNumberHelper';

export const borderRadiusDecorator = ({ radius }: BorderRadiusInterface) => {
	return radius ? `border-radius: ${stringOrNumberHelper(radius, 'rem')};` : ``;
};
